import { ImageFilterCenterFocusIcon } from './ImageFilterCenterFocusIcon';

/**
 * author: Google
 * id E3745997-1AD2-4D79-83FE-72ADE96E3C69
 * name image-filter-center-focus
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/image-filter-center-focus.svg
 * tags
 * - Photography 
 */
export const ImageFilterCentreFocusIcon = ImageFilterCenterFocusIcon;
export default ImageFilterCentreFocusIcon